<template>
    <div class="inner-wrapper">
      <div class="editor-wrapper" v-show="!reportShow">
        <div class="title-wrapper">
          <span>{{base_info.title_ch}}</span>
        </div>
        <van-search placeholder="请输入委托单编号关键词" v-model="optionData.project_display_no" @search="onSearch" />
        <van-search placeholder="请输入报告编号关键词" v-model="optionData.report_display_no" @search="onSearch" />
        <van-list
          v-model="reportTable.loading"
          :finished="reportTable.finished"
          finished-text="没有更多了"
          :error.sync="reportTable.error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <van-cell
            v-for="item in reportTable.tivdata"
            :key="item.report_display_no+'verify'"
            :title="item.report_display_no+item.alter_mark+''"
            :label="item.company_name"
            @click="chooseReport(item)"
            is-link
          >
          <span class="cell-item">{{item.reporter}}</span>
          <span class="cell-item">{{item.report_date}}</span>
          
          </van-cell>
        </van-list>
      </div>
      <div class="report-wrapper" v-show="reportShow">
        <van-nav-bar
          :title="currentReport.report_display_no+currentReport.alter_mark+''"
          left-text="返回"
          left-arrow
          @click-left="onClickBack"
          fixed
        >
        <span slot="right">
          <span  class="op" @click="commit" v-if="base_info.op_title">{{base_info.op_title}}</span>
          <span  class="op deny" @click="deny" v-if="base_info.op_title">驳回</span>
        </span>
        
        </van-nav-bar>
        <report-view :report_no="currentReport.report_no"></report-view>
      </div>
      <van-dialog
      title="确认驳回"
      v-model="rejectModal"
      show-cancel-button
      :before-close="reject"
    >
      <div class="text-wrapper">
        <p>编号：<span class="bold-text">{{currentReport.report_display_no+currentReport.alter_mark}}</span></p>
        <p>检测人：<span class="bold-text">{{currentReport.reporter}}</span></p>
        <p>请填写驳回意见：</p>
        <textarea class="textarea" v-model="rejectText" placeholder="驳回意见可供报告出具者在修改报告时参考"></textarea>
      </div>
    </van-dialog>
    <van-dialog
      title="下述报告将通过审核"
      v-model="confirmModal"
      show-cancel-button
      :before-close="confirm"
    >
      <div class="text-wrapper-con">
        <p>编号：<span class="bold-text">{{currentReport.report_display_no+currentReport.alter_mark}}</span></p>
        <p>检测人：<span class="bold-text">{{currentReport.reporter}}</span></p>
      </div>
    </van-dialog>
    </div>
</template>
<script>
import reportView from "./ReportView.vue";
let userToken = localStorage.getItem("current_user_token");

const OPTIONDATA = {
  test_catagory:[
    {text:'全部类别',value:''},
    {text:'金相',value:'J'},
    {text:'力学',value:'L'},
    {text:'化学',value:'H'},
    {text:'铁路',value:'T'},
    {text:'综合',value:'Z'},
    ],
  report_stat:[
    {text:'全部状态',value:''},
    {text:'待接收',value:'待接收'},
    {text:'待出具',value:'待出具'},
    {text:'待提交',value:'待提交'},
    {text:'待修改',value:'待修改'},
    {text:'待审核',value:'待审核'},
    {text:'待批准',value:'待批准'},
    {text:'已完成',value:'已完成'},
    {text:'已打印',value:'已打印'},
    {text:'已寄出',value:'已寄出'},
    {text:'已作废',value:'已作废'},
  ],
  period:[
    {text:'全部限期',value:''},
    {text:'当前逾期',value:'-1'},
    {text:'接近逾期',value:'1'},
    {text:'历史逾期',value:'history-1'},
  ],
  date_type:[
    {text:'要求日期',value:'demand_date'},
    {text:'出具日期',value:'report_date'},
    {text:'审核日期',value:'verify_date'},
    {text:'批准日期',value:'approve_date'},
    {text:'委托日期',value:'create_date'},
  ],
  language:[
    {text:'全部语言',value:''},
    {text:'English',value:'English'},
    {text:'中文(简体)',value:'中文(简体)'},
  ],
  stamp:[
    {text:'全部印章',value:''},
    {text:'有CNAS无CMA',value:'cnas'},
    {text:'有CMA无CNAS',value:'cma'},
    {text:'CNAS/CMA均有',value:'+cnas+cma'},
    {text:'CNAS/CMA均无',value:'-cnas-cma'},
  ],
  order:[
    {text:'默认排序',value:''},
    {text:'要求日期',value:'demand'},
    {text:'委托日期',value:'create'},
    {text:'完成日期',value:'complete'},
  ],
  esc:[
    {text:'排序方向',value:'DESC'},
    {text:'倒序',value:'DESC'},
    {text:'顺序',value:'ESC'}
  ]
}

function optionDataFac(){
  return {
    project_display_no:'',
    report_display_no:'',
    test_catagory:OPTIONDATA.test_catagory[0].value,
    report_stat:OPTIONDATA.report_stat[0].value,
    period:OPTIONDATA.period[0].value,
    date_type:OPTIONDATA.date_type[0].value,
    start_date:'',
    end_date:'',
    if_ac:false,
    completed:false,
    keyword:'',
    company_name:'',
    standard:'',
    language:'',
    stamp:'',
    order:'',
    esc:OPTIONDATA.esc[0].value
  };
}

export default {
  name: "reportVa",
  components: {
    reportView,
  },
  props: {
    base_info: {
      type: Object,
      default() {
        return {
          title_ch: "",
          op_title: "",
          post_url: "",
          askData: "",
          opAskData:''
        };
      }
    },
  },
  data() {
    return {
      optionData:optionDataFac(),
      reportTable: {
        loading: false,
        finished: false,
        error: false,
        Tpage: {
          currentPage: 1,
          currentSize: 20
        },
        no_data_text: "",
        totalItems: 0,
        tivdata: [
          /*{
            contract_no: NaN,
            report_display_no:NaN,
            report_no: NaN,
            reporter: "",
            report_date: ""
          }*/
        ]
      },
      reportShow:false,
      currentReport:{},
      rejectText: "",
      rejectModal:false,
      confirmModal:false,
      
    };
  },
  watch: {
  },
  computed: {},
  created() {
  },
  methods: {
    onLoad() {
      this.reportTable.loading = true;
      this.$axios
        .post(this.$url + this.base_info.post_url, {
          page: this.reportTable.Tpage,
          userToken: userToken,
          ask_data: this.base_info.askData,
          optionData:this.optionData,
        })
        .then(response => {
          for(let ele of response.data.res_record){
            this.reportTable.tivdata.push(ele);
          }
          if(response.data.res_record.length<this.reportTable.Tpage.currentSize){
            this.reportTable.finished = true
          }
          this.reportTable.loading = false;
          this.reportTable.Tpage.currentPage++;
        });
    },
    onSearch(){
      this.reportTable.tivdata.splice(0,this.reportTable.tivdata.length);
      this.reportTable.Tpage.currentPage = 1;
      this.onLoad();
    },
    chooseReport(val){
      this.currentReport = val;
      if(this.currentReport.report_id){
        this.currentReport.report_no = this.currentReport.report_id;//pc端和web端同时改掉审核和批准的数据接口后即可删除
      }
      this.reportShow = true;
    },
    onClickBack(){
      this.reportShow = false;
    },
    commit(){
      this.confirmModal = true;
    },
    deny(){
      this.rejectModal = true;
    },
    confirm(action,done){
      if(action==='confirm'){
            this.do_report(done,this.currentReport.report_no, "yes");
          }else{
            done();
          }
    },
    reject(action,done){
      if(action==='confirm'){
            this.do_report(done,this.currentReport.report_no,'no',this.rejectText)
          }else{
            done();
          }
    }, 
    do_report(done,report_no, yesOrNo, opinion = "") {
      this.$axios
        .post(this.$url + "/audit_report", {
          userToken: userToken,
          askData: this.base_info.opAskData,
          report_id: report_no,
          yesOrNo: yesOrNo,
          opinion: opinion
        })
        .then(response => {
          if (response.data.stat == "ok") {
            this.$toast.success("操作成功！");
            done();
            this.reportShow = false;
            let index = this.reportTable.tivdata.findIndex(val=>val.report_no===report_no);
            this.reportTable.tivdata.splice(index,1);
          } else {
            this.$toast.fail("操作失败，信息有误！");
          }
        }).catch(
          error=>{
            this.$toast.fail("无法连接到服务器！"+error);
          }
        );
    }
  }
};
</script>
<style scoped>
.inner-wrapper {
  width: 100%;
  background: #f7f7f7;
  min-height:20rem;
}

.title-wrapper {
  text-align: center;
  font-size: 0.8rem;
  color:#999;
  padding: 1rem;
  background: #fff;
  border-bottom:1px solid #f6f6f6;
}

.editor-wrapper {
  width:100%;
}
.cell-item{
  margin-left:0.6rem;
}

.op{
  outline: none;
  border:1px solid #eee;
  color:#fff;
  background: rgb(11, 155, 18);
  font-weight: 400;
  height:1rem;
  position: relative;
  top:0.05rem;
  padding: 0.15rem 0.5rem;
  border-radius: 0.2rem;
}
.deny{
  background: rgb(228, 46, 14);
  margin-left:0.5rem;
}

.text-wrapper{
  padding: 0.1rem 0.5rem;

}
.text-wrapper-con{
  padding:1rem 0 1rem 2rem; 
}

.textarea{
  width:100%;
  height:7rem;
}
.bold-text{
  font-weight: 600;
  color:#666;
}

</style>